import { Alert as AntAlert } from "antd";

export function Alert({ message, type }) {
  return <AntAlert message={message} type={type || 'error'} showIcon />;
}
